<form>
  <div class="ui-g">
    <div class="ui-g-12 ui-md-8 ui-lg-8">
      <div class="ui-g">
        <div class="ui-g-12 ui-md-6 ui-lg-6">Partner Payee Name</div>
        <div class="ui-g-12 ui-md-6 ui-lg-6">
          {{
            !paymentProfileDetails.payeeName
              ? 'N/A'
              : paymentProfileDetails.payeeName
          }}
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-6 ui-lg-6">Payee Contact Name</div>
        <div class="ui-g-12 ui-md-6 ui-lg-6">
          {{
            !paymentProfileDetails.payeeContactName
              ? 'N/A'
              : paymentProfileDetails.payeeContactName
          }}
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-6 ui-lg-6">Payee Contact Email</div>
        <div class="ui-g-12 ui-md-6 ui-lg-6">
          {{
            !paymentProfileDetails.payeeContactEmail
              ? 'N/A'
              : paymentProfileDetails.payeeContactEmail
          }}
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-6 ui-lg-6">Vendor ID</div>

        <div class="ui-g-12 ui-md-6 ui-lg-6">
          {{
            paymentProfileDetails.vendorId
              ? paymentProfileDetails.vendorId
              : '-'
          }}
        </div>
      </div>
      <div class="ui-g">
        <div
          class="ui-xl-6 ui-g-12 ui-md-6 ui-lg-6 align-activity pl-0 pr-0 mb-1">
          <span
            class="activity-font font-bold payment-title align pr-2"
            aria-label="Payment profile"
            ><i class="mdl2-payment-profile mr-2"></i>Payment profile</span
          >
        </div>
        <div class="ui-xl-6 ui-g-12 ui-md-6 ui-lg-6 activity-font">
          <div
            class="font-bold"
            aria-label="payment profile status"
            [ngClass]="paymentProfileDetails.statusColor">
            {{
              getPaymentProfileStatus(
                paymentProfileDetails.paymentProfileStatusDescription
              )
            }}
          </div>
        </div>
      </div>
      <div class="ui-g">
        <div
          class="ui-xl-6 ui-g-12 ui-md-6 ui-lg-6 align-activity pl-0 pr-0 mb-1">
          <span class="activity-font font-bold payment-title align pr-2"
            ><i class="mdl2-contract-status mr-2"></i>Program agreement</span
          >
        </div>
        <div class="ui-xl-6 ui-g-12 ui-md-6 ui-lg-6 activity-font">
          @if (paymentProfileDetails.programAgrementStatus) {
            <div class="font-bold green" aria-label="Green">Green</div>
          }
          @if (!paymentProfileDetails.programAgrementStatus) {
            <div class="font-bold red" aria-label="Red">Red</div>
          }
        </div>
      </div>
    </div>
  </div>
</form>
